export enum IExpeditionType {
    'Fixed' = 'Fixed',
    'HybridWithFixedPoints' = 'HybridWithFixedPoints',
    'Dynamic' = 'Dynamic',
    'DynamicWithFixedPoints' = 'DynamicWithFixedPoints',
    'HybridDoor2Door' = 'HybridDoor2Door',
    'DynamicDoor2Door' = 'DynamicDoor2Door',
    'Door2Door' = 'Door2Door'
  }
  